export default function GoalProgress({ progressPercent, projects, projectTasksMap }) {
  // Calculate per-project progress
  const projectProgress = projects.map(project => {
    const tasks = projectTasksMap[project.id] || [];
    const total = tasks.length;
    const completed = tasks.filter(t => t.completedAt).length;
    const percent = total > 0 ? Math.round((completed / total) * 100) : 0;

    return {
      id: project.id,
      name: project.name,
      total,
      completed,
      percent,
    };
  });

  // Color palette for projects (cycling through)
  const colors = [
    'bg-purple-500',
    'bg-blue-500',
    'bg-emerald-500',
    'bg-amber-500',
    'bg-pink-500',
    'bg-cyan-500',
  ];

  return (
    <div className="mb-6">
      {/* Main progress bar */}
      <div className="mb-3">
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-xs text-text-secondary font-medium">Overall Progress</span>
          <span className="text-xs text-text-tertiary">{progressPercent}%</span>
        </div>
        <div className="h-2.5 bg-surface-hover rounded-full overflow-hidden">
          <div
            className="h-full bg-accent rounded-full transition-all duration-500 ease-out"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>

      {/* Per-project breakdown (only show if there are projects with tasks) */}
      {projectProgress.filter(p => p.total > 0).length > 0 && (
        <div className="space-y-2">
          <span className="text-[10px] text-text-tertiary uppercase tracking-wide">By Project</span>
          <div className="space-y-1.5">
            {projectProgress.filter(p => p.total > 0).map((project, index) => (
              <div key={project.id} className="flex items-center gap-2">
                <div className="w-24 truncate">
                  <span className="text-[10px] text-text-secondary">{project.name}</span>
                </div>
                <div className="flex-1 h-1.5 bg-surface-hover rounded-full overflow-hidden">
                  <div
                    className={`h-full rounded-full transition-all duration-500 ease-out ${colors[index % colors.length]}`}
                    style={{ width: `${project.percent}%` }}
                  />
                </div>
                <div className="w-12 text-right">
                  <span className="text-[10px] text-text-tertiary">
                    {project.completed}/{project.total}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
